<label [for]="uniqueId" *ngIf="!filePreview">
  <studio-button-legacy theme="dark-primary" (click)="openFileBrowser()">
    {{ uploadButtonText }}
  </studio-button-legacy>
</label>

<input
  #fileInput
  [id]="uniqueId"
  type="file"
  [accept]="fileType"
  multiple="false"
  (change)="fileSelected($event.target)"
/>

<div class="file-selection-actions" *ngIf="filePreview">
  <div class="selected-file">
    <p class="file-preview bold-text small-text">{{ filePreview }}</p>
  </div>

  <div class="actions">
    <label [for]="uniqueId">
      <studio-button-legacy theme="dark-secondary" (click)="openFileBrowser()">
        {{ updateButtonText }}
      </studio-button-legacy>
    </label>

    <studio-button-legacy
      [disabled]="disableRemoveButton"
      theme="dark-secondary"
      (click)="removeFile()"
    >
      Remove
    </studio-button-legacy>
  </div>
</div>
